export default __webpack_public_path__ + "static/media/helpIcon.71469fbd.svg";